import React, { useState, useEffect, useRef } from "react";
import "./Onboarding.css";
import { useNavigate } from 'react-router-dom';
import { FaUsers, FaVideo, FaCalendar, FaAward, FaChevronRight, FaPlus } from  "react-icons/fa";
// import HRCopilotOnboardingHero from "./HRCopilotOnboardingHero";
// import HRCopilotOnboardingStatus from "./HRCopilotOnboardingStatus";
// import HRCopilotOnboardingPipeline from "./HRCopilotOnboardingPipeline";
// import HRCopilotEraSection from "./HRCopilotEraSection";
import HRCopilotExploreSection from "./HRCopilotOnboardingSection";
// import HRCopilotFeatures from "./HRCopilotOnboardingFeatures";
import HRCopilotFeatures from './HRCopilotFeatures';
// import Management from './Management';
// import HRNewsletter from "./HRNewsletter";
import HRCopilotNewsSection from "./HRCopilotNewsSection";
// import HRCopilotStatsSection from "./HRCopilotStatsSection";
import OnboardWiseCode from './OnboardWiseCode';
import useSEO from "../utils/useSEO";




const VideoPopup = ({ isOpen, onClose, videoUrl }) => {
  const videoRef = useRef(null);




  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
      }
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;



  return (
    <div className="onboarding-video-popup-overlay" onClick={onClose}>
      <div className="onboarding-video-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="onboarding-video-popup-close" onClick={onClose}>
          ×
        </button>
        <div className="onboarding-video-container">
          <video ref={videoRef} controls autoPlay className="onboarding-demo-video">
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="onboarding-video-popup-info">
          <h3>Platform Walkthrough</h3>
          <p>See how our onboarding platform creates exceptional employee experiences from day one</p>
        </div>
      </div>
    </div>
  );
};

const Onboarding = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const [activeProgress, setActiveProgress] = useState(0);
  const [hoveredIntegration, setHoveredIntegration] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [activeIntegration, setActiveIntegration] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
    const navigate = useNavigate();
      const stepCardsRef = useRef([]);
 const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

   useSEO({
    title: "Recruitment, Staffing & Employee Onboarding | Humanex",
    description:
      "Explore Humanex recruitment, staffing, and employee onboarding services designed to streamline hiring, reduce turnaround time, and improve workforce readiness.",
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    stepCardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      stepCardsRef.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);


  const addToRefs = (el) => {
    if (el && !stepCardsRef.current.includes(el)) {
      stepCardsRef.current.push(el);
    }
  };

   const toggleDropdown = (stepId) => {
    setActiveDropdown(activeDropdown === stepId ? null : stepId);
  };

  const openModal = (stepId) => {
    setActiveModal(stepId);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

    const handleAccessRecruit = () => navigate('/payment');
        const handleAccess = () => navigate('/access-recruit');


  useEffect(() => {
    setIsVisible(true);
    
    // Auto rotate features
    const interval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % 6);
    }, 4000);
    
    // Scroll progress
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const demoVideoUrl = "https://assets.mixkit.co/videos/preview/mixkit-close-up-of-businesswoman-using-her-laptop-5082-large.mp4";

  const openVideoPopup = () => {
    setIsVideoPopupOpen(true);
  };

  const closeVideoPopup = () => {
    setIsVideoPopupOpen(false);
  };

  const features = [
    {
      icon: "🚀",
      title: "Automated Workflows",
      description: "Streamline onboarding with intelligent automation and customizable templates"
    },
    {
      icon: "📊",
      title: "Progress Tracking",
      description: "Real-time dashboards to monitor completion rates and identify bottlenecks"
    },
    {
      icon: "🔒",
      title: "Secure & Compliant",
      description: "Enterprise security with built-in compliance for global regulations"
    },
    {
      icon: "🎯",
      title: "Personalized Experience",
      description: "Tailored onboarding journeys for different roles and departments"
    },
    {
      icon: "🔄",
      title: "Seamless Integration",
      description: "Connect with your existing HR systems and productivity tools"
    },
    {
      icon: "📱",
      title: "Mobile Ready",
      description: "Complete onboarding tasks from any device, anywhere"
    }
  ];

  const onboardingSteps = [
    {
      phase: "Pre-Arrival",
      title: "Digital Welcome & Preparation",
      steps: ["Offer Acceptance", "Digital Paperwork", "Welcome Kit", "System Access"],
      time: "1-2 weeks before start"
    },
    {
      phase: "First Week",
      title: "Orientation & Integration",
      steps: ["Company Orientation", "Team Introductions", "Training Sessions", "Goal Setting"],
      time: "Week 1"
    },
    {
      phase: "First 90 Days",
      title: "Development & Engagement",
      steps: ["Mentor Matching", "Skill Development", "Performance Check-ins", "Culture Integration"],
      time: "Months 1-3"
    }
  ];

const progressItems = [
    { name: "Paperwork & Compliance", progress: 92, icon: "📋", color: "#6366f1" },
    { name: "Training Modules", progress: 78, icon: "🎓", color: "#8b5cf6" },
    { name: "Team Introductions", progress: 100, icon: "👋", color: "#10b981" },
    { name: "Equipment Setup", progress: 65, icon: "💻", color: "#f59e0b" },
    { name: "System Access", progress: 88, icon: "🔐", color: "#3b82f6" },
    { name: "Goal Setting", progress: 72, icon: "🎯", color: "#ec4899" }
  ];

  const integrations = [
    { name: 'Slack', icon: '💬', category: 'Communication', status: 'Active', users: '2.4K' },
    { name: 'Microsoft Teams', icon: '👥', category: 'Collaboration', status: 'Active', users: '1.8K' },
    { name: 'Workday', icon: '📊', category: 'HRIS', status: 'Active', users: '3.1K' },
    { name: 'Google Workspace', icon: '🌐', category: 'Productivity', status: 'Active', users: '2.9K' },
    { name: 'Office 365', icon: '📝', category: 'Productivity', status: 'Active', users: '2.2K' },
    { name: 'Salesforce', icon: '📈', category: 'CRM', status: 'Active', users: '1.5K' },
    { name: 'Zoom', icon: '🎥', category: 'Video', status: 'Active', users: '2.7K' },
    { name: 'ADP', icon: '💰', category: 'Payroll', status: 'Active', users: '3.3K' },
    { name: 'BambooHR', icon: '🎋', category: 'HRIS', status: 'Active', users: '1.9K' },
    { name: 'Jira', icon: '🎯', category: 'Project Mgmt', status: 'Active', users: '2.1K' },
    { name: 'Confluence', icon: '📚', category: 'Documentation', status: 'Active', users: '1.6K' },
    { name: 'LinkedIn', icon: '💼', category: 'Recruiting', status: 'Active', users: '2.8K' }
  ];

  const steps = [
    {
      id: 1,
      number: '01',
      title: 'Create Your Account',
      description: 'Begin your journey by creating a secure personal account. Our streamlined registration process ensures you can start exploring our platform in under two minutes. Simply provide your basic information, verify your email address, and establish your unique login credentials.',
      detailedContent: {
        features: [
          'Secure email verification with instant confirmation',
          'Two-factor authentication for enhanced security',
          'Real-time password strength indicators and suggestions',
          'Multiple account recovery options including phone and security questions',
          'Privacy-focused data collection with GDPR compliance',
          'Automatic session management and secure logout'
        ],
        tips: 'For optimal security, we recommend choosing a password with at least 12 characters that includes uppercase and lowercase letters, numbers, and special symbols. Avoid using personal information that could be easily guessed.',
        additionalInfo: 'Your account serves as the foundation for your entire experience on our platform. It securely stores your preferences, progress, and personal data while giving you full control over your privacy settings. All data is encrypted using industry-standard AES-256 encryption.',
        requirements: [
          'Valid email address for verification',
          'Password minimum 8 characters',
          'Agreement to our terms of service and privacy policy'
        ],
        timeEstimate: '2-3 minutes',
        successRate: '98% completion rate'
      },
      buttonText: 'Get Started Now',
      image: '/images/one1.png',
      hasDropdown: true,
      hasModal: true
    },
    {
      id: 2,
      number: '02',
      title: 'Customize Your Profile',
      description: 'Transform your account into a personalized digital identity that truly represents you. Upload professional photos, craft an engaging bio, and configure your preferences to create an experience tailored specifically to your needs and workflow preferences.',
      detailedContent: {
        features: [
          'High-resolution profile photo upload with automatic optimization',
          'Comprehensive professional biography with rich text formatting',
          'Customizable notification preferences across all device types',
          'Multiple theme options including dark mode and high contrast',
          'Language selection supporting 15+ international languages',
          'Accessibility features including screen reader compatibility'
        ],
        tips: 'Studies show that profiles with professional headshots receive 45% more engagement and are perceived as more trustworthy. Consider using a clear, well-lit photo where your face takes up at least 60% of the frame.',
        additionalInfo: 'Your profile is your digital business card within our ecosystem. It helps other users understand your expertise and interests while allowing our system to provide more relevant recommendations and content. All profile information can be updated at any time.',
        requirements: [
          'Profile photo (recommended: 500x500 pixels)',
          'Basic personal information',
          'Privacy preference selection'
        ],
        timeEstimate: '5-7 minutes',
        successRate: '92% completion rate'
      },
      buttonText: 'Customize Profile',
      image: '/images/one2.png',
      hasDropdown: true,
      hasModal: true
    },
    {
      id: 3,
      number: '03',
      title: 'Explore Platform Features',
      description: 'Dive deep into our comprehensive suite of tools and capabilities designed to streamline your workflow and boost productivity. From advanced analytics dashboards to collaborative workspaces, discover how each feature can transform your daily operations and help you achieve your objectives more efficiently.',
      detailedContent: {
        features: [
          'Interactive dashboard with real-time analytics and KPI tracking',
          'Advanced project management tools with Gantt charts and timelines',
          'Collaborative workspaces with simultaneous multi-user editing',
          'Integration marketplace with 100+ third-party applications',
          'Automated reporting system with customizable templates',
          'Advanced search functionality with natural language processing'
        ],
        tips: 'We highly recommend taking our 10-minute interactive platform tour, which has been shown to help new users discover 68% more features within their first week. The tour adapts to your specific use case and highlights relevant tools.',
        additionalInfo: 'Our platform is built on a modular architecture, allowing you to enable or disable features based on your specific needs. This ensures a clean, focused interface while maintaining access to powerful tools when required. Regular feature updates are released monthly based on user feedback.',
        requirements: [
          'Completed basic account setup',
          'Stable internet connection',
          'Modern web browser (Chrome, Firefox, Safari, or Edge)'
        ],
        timeEstimate: '10-15 minutes',
        successRate: '85% completion rate'
      },
      buttonText: 'Explore Features',
      image: '/images/one3.png',
      hasDropdown: true,
      hasModal: true
    },
    {
      id: 4,
      number: '04',
      title: 'Connect & Collaborate with Your Team',
      description: 'Build your professional network and establish seamless collaboration channels with colleagues, partners, and team members. Our advanced collaboration tools facilitate real-time communication, file sharing, and project coordination across different time zones and geographical locations.',
      detailedContent: {
        features: [
          'Smart team invitation system with role-based permissions',
          'Real-time messaging with file sharing and emoji reactions',
          'High-definition video conferencing with screen sharing capabilities',
          'Advanced file management with version control and commenting',
          'Task delegation system with deadlines and progress tracking',
          'Cross-platform compatibility across web, mobile, and desktop'
        ],
        tips: 'Start by inviting a small core team of 3-5 members to familiarize yourself with collaboration features. Research shows that teams who gradually onboard members experience 40% fewer configuration issues and achieve full productivity faster.',
        additionalInfo: 'Our collaboration infrastructure supports teams of all sizes, from small startups to enterprise organizations with thousands of users. All collaborative activities are protected by end-to-end encryption, and you maintain complete control over data sharing permissions and access levels.',
        requirements: [
          'Active team member email addresses',
          'Defined team roles and responsibilities',
          'Collaboration guidelines and best practices'
        ],
        timeEstimate: '8-12 minutes',
        successRate: '88% completion rate'
      },
      buttonText: 'Invite Team Members',
      image: '/images/one4.png',
      hasDropdown: true,
      hasModal: true
    },
    {
      id: 5,
      number: '05',
      title: 'Configure Advanced System Settings',
      description: 'Fine-tune your platform experience with powerful customization options and advanced configuration settings. Optimize performance, enhance security protocols, integrate with your existing toolchain, and automate repetitive tasks to create a perfectly tailored working environment.',
      detailedContent: {
        features: [
          'Comprehensive API access with detailed documentation and examples',
          'Custom workflow automation with visual workflow builder',
          'Third-party integration support for 50+ popular business tools',
          'Advanced security settings including IP whitelisting and session controls',
          'Performance optimization tools and bandwidth management',
          'Custom reporting and analytics configuration'
        ],
        tips: 'Enable two-factor authentication immediately for all administrative accounts. This simple step prevents 99.9% of automated attacks and significantly enhances your organizational security posture without impacting user experience.',
        additionalInfo: 'Advanced settings are designed for power users and administrators who require granular control over their platform experience. These configurations can significantly impact system performance and security, so we recommend reviewing each setting carefully and consulting our documentation before making changes.',
        requirements: [
          'Administrator-level permissions',
          'Technical understanding of system configurations',
          'Backup of current settings before major changes'
        ],
        timeEstimate: '15-20 minutes',
        successRate: '76% completion rate'
      },
      buttonText: 'Configure Settings',
      image: '/images/one5.png',
      hasDropdown: true,
      hasModal: true
    },
    {
      id: 6,
      number: '06',
      title: 'Access Comprehensive Support & Learning Resources',
      description: 'Tap into our extensive knowledge ecosystem featuring 24/7 customer support, detailed documentation, interactive tutorials, and an active community forum. Whether you need quick answers or in-depth training, our support infrastructure ensures you have the resources to succeed.',
      detailedContent: {
        features: [
          '24/7 multilingual customer support via chat, email, and phone',
          'Comprehensive knowledge base with 500+ detailed articles and guides',
          'Video tutorial library with step-by-step walkthroughs',
          'Active community forum with 50,000+ members and experts',
          'Regular live webinars and virtual training sessions',
          'Personalized learning paths and certification programs'
        ],
        tips: 'Join our community forum within your first week to connect with other users. Forum participants report solving problems 65% faster and discovering innovative uses for platform features they might otherwise have missed.',
        additionalInfo: 'Our support team maintains an average response time of under 2 minutes for chat support and 4 hours for email inquiries. The knowledge base is updated weekly with new content based on user feedback and frequently asked questions. All support services are included with your subscription at no additional cost.',
        requirements: [
          'Active platform subscription',
          'Basic understanding of your specific needs',
          'Willingness to engage with community resources'
        ],
        timeEstimate: '5-8 minutes',
        successRate: '94% completion rate'
      },
      buttonText: 'Access Support',
      image: '/images/on6.png',
      hasDropdown: true,
      hasModal: true
    }
  ];

  return (
    <div className="onboarding-container">
      {/* Scroll Progress Bar */}
      {/* <div className="onboarding-scroll-progress" style={{width: `${scrollProgress}%`}}></div> */}

      {/* Video Popup */}
      <VideoPopup 
        isOpen={isVideoPopupOpen} 
        onClose={closeVideoPopup} 
        videoUrl={demoVideoUrl}
      />

      {/* Enhanced Animated Background */}
      <div className="onboarding-background-animation">
        {/* <div className="onboarding-floating-shape onboarding-shape-1"></div>
        <div className="onboarding-floating-shape onboarding-shape-2"></div>
        <div className="onboarding-floating-shape onboarding-shape-3"></div>
        <div className="onboarding-floating-shape onboarding-shape-4"></div>
        <div className="onboarding-floating-shape onboarding-shape-5"></div> */}
        
        {/* Animated Gradient Orbs */}
        {/* <div className="onboarding-gradient-orb onboarding-orb-1"></div>
        <div className="onboarding-gradient-orb onboarding-orb-2"></div>
        <div className="onboarding-gradient-orb onboarding-orb-3"></div> */}
        
        {/* SVG Background Animation */}
        <svg className="onboarding-bg-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <linearGradient id="onboarding-gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(74, 144, 226, 0.08)" />
              <stop offset="50%" stopColor="rgba(120, 119, 216, 0.05)" />
              <stop offset="100%" stopColor="rgba(226, 74, 144, 0.08)" />
            </linearGradient>
            <linearGradient id="onboarding-gradient2" x1="100%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(120, 119, 216, 0.06)" />
              <stop offset="50%" stopColor="rgba(119, 216, 216, 0.04)" />
              <stop offset="100%" stopColor="rgba(74, 226, 144, 0.06)" />
            </linearGradient>
            <pattern id="onboarding-grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#onboarding-grid)" />
          <path 
            d="M0,15 Q30,5 60,25 T100,35 L100,100 L0,100 Z" 
            fill="url(#onboarding-gradient1)"
            className="onboarding-svg-path-1"
          />
          <path 
            d="M0,65 Q40,45 80,70 T100,85 L100,100 L0,100 Z" 
            fill="url(#onboarding-gradient2)"
            opacity="0.8"
            className="onboarding-svg-path-2"
          />
        </svg>
      </div>

    

      {/* Enhanced Hero Section */}
      <HRCopilotExploreSection/>
      <OnboardWiseCode/>
      <HRCopilotFeatures/>
      <HRCopilotNewsSection/>

{/* <HRCopilotOnboardingHero/> */}
 {/* <Management/> */}
 
{/* <HRCopilotEraSection/>
<HRCopilotOnboardingStatus/>
<HRCopilotStatsSection/> */}
{/* <HRCopilotOnboardingPipeline/> */}
{/* <HRCopilotOnboardingFeatures/> */}

    </div>
  );
};

export default Onboarding;